import "./App.css";
import {
  Navigate,
  Route,
  Routes
} from "react-router-dom";
import React from "react";
import Login from "./pages/Login";
import UserDashboard from "./pages/UserDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Bind from "./pages/Bind";
import Purchase from "./pages/Purchase";
import VerifyEmail from "./components/VerifyEmail";
import Register from "./pages/Register";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import { UsersProvider } from "./context/UsersContext";
import { PurchaseLinksProvider } from "./context/PurchaseLinksContext";
import Subscribe from "./pages/Subscribe";
import { LicencesProvider } from "./context/LicenceContext";

function App() {
  return (
    <Routes>
      <Route index={true} element={<><Navigate to="/dashboard" /></>} />

      <Route path="/verify/:token" element={<VerifyEmail />} />

      <Route path="/r/:refUserId" element={<Purchase />} />

      <Route path="/purchase/:key" element={<Purchase />} />

      <Route path="/admin" element={
        <ProtectedRoute isAdmin={true}>
          <UsersProvider>
            <PurchaseLinksProvider>
              <LicencesProvider>
                <AdminDashboard />
              </LicencesProvider>
            </PurchaseLinksProvider>
          </UsersProvider>
        </ProtectedRoute>
      } />

      <Route path="/login" element={<Login />} />

      <Route path="/register" element={<Register />} />

      <Route path="/subscribe" element={
        <ProtectedRoute>
          <Subscribe />
        </ProtectedRoute>
      } />

      <Route path="/bind" element={
        <ProtectedRoute>
          <Bind />
        </ProtectedRoute>
      } />

      <Route path="/dashboard" element={
        <ProtectedRoute isAdmin={false}>
          <UserDashboard />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
